const required = value => (value ? undefined : "Wymagane")

const mustBeNumber = value => (isNaN(value) ? "Wartość musi być cyfrą" : '')

const minValue = min => value =>
  isNaN(value) || value >= min ? undefined : `Musi być dłuższe niż ${min}`

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const isEmail = value =>
  ((typeof value === 'string' && emailRegex.test(value)) ? undefined : "Wprowadź email")

const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => (error || validator(value)), undefined);

export {
  required,
  mustBeNumber,
  minValue,
  isEmail,
  composeValidators
}